<template>
  <div class="cj-layout" :class="{ game: isGame }" :style="layoutStyle">
    <div class="container arcade" :style="arcadeStyle">
      <CJHeader :disabled="!isAtLeast13" :hide-logo="isGame" />

      <div class="container screen-wrapper">
        <main>
          <transition name="fade">
            <slot />
          </transition>
        </main>
      </div>

      <CJFooter :game-mode="isGame" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { prop } from 'ramda'
import bean from 'bean'

import CJHeader from '@/components/CJHeader'
import CJFooter from '@/components/CJFooter'

const MOBILE_WIDTH = 482
const MOBILE_HEIGHT = 902
const MOBILE_HEIGHT_GAME = 928

const DESKTOP_WIDTH = 1129
const DESKTOP_HEIGHT = 888
const DESKTOP_HEIGHT_GAME = 878

export default {
  name: 'CJLayout',

  components: { CJHeader, CJFooter },

  props: {
    dense: {
      type: Boolean,
    },
  },

  mounted () {
    this.updateViewport()
    bean.on(window, 'resize', () => this.updateViewport())
  },

  beforeDestroy () {
    bean.off()
  },

  data () {
    return {
      vw: null,
      vh: null,
    }
  },

  computed: {
    ...mapState({
      isAtLeast13: prop('isAtLeast13'),
    }),

    isGame () {
      return this.$route.name === 'game'
    },

    width () {
      if (!this.vw) return null
      return this.vw < 1024 ? MOBILE_WIDTH : DESKTOP_WIDTH
    },

    height () {
      if (!this.vw) return null

      return this.vw < 1024
        ? this.isGame
          ? MOBILE_HEIGHT_GAME
          : MOBILE_HEIGHT
        : this.isGame
          ? DESKTOP_HEIGHT_GAME
          : DESKTOP_HEIGHT
    },

    scale () {
      if (!this.vw && !this.vh) return null
      return Math.min(this.vw / this.width, this.vh / this.height)
    },

    layoutStyle () {
      if (!this.scale) return null

      return {
        width: `${this.scale * this.width}px`,
        height: `${this.scale * this.height}px`,
      }
    },

    arcadeStyle () {
      return this.scale && { transform: `scale(${this.scale})` }
    },
  },

  methods: {
    updateViewport () {
      this.vw = window.innerWidth
      this.vh = window.innerHeight
    },
  },
}
</script>

<style lang="stylus" scoped>
  .cj-layout
    overflow: hidden
    margin: 0 auto

    > .arcade
      display: flex
      flex-flow: column nowrap
      overflow: hidden
      width: 482px
      transform-origin: top left

      @media screen and (min-device-width: 1024px)
        width: 1129px

      .cj-header
      .cj-footer
        z-index: 2
        flex: none

      > .screen-wrapper
        > main
          height: 100%
          overflow: hidden

    &.game
      > .arcade
        > .screen-wrapper
          > main
            left: 0
            width: 100%
            overflow-y: hidden
</style>
